import { Ticket } from "@/models/tienda/Ticket";
import { User, UserState } from "./interfaces";

export default (): UserState => ({
    isLoading: false,
    perfil: {} as User,
    familia: [],
    tickets: [],
});
